var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRsvpPresent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 96.5",
    style: {
      enableBackground: "new 0 0 100 96.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.rsvp-present-st0{fill:#C7D41A;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "rsvp-present-st0",
    d: "M38.6,74.1c-6.2,1.3-11.6,0.1-10.1,7.3s7.8,11.9,14,10.6c6.2-1.3,10.1-8.4,8.6-15.5 C49.6,69.3,44.9,72.7,38.6,74.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "rsvp-present-st0",
    d: "M38.1,71c0.4-0.1,0.8-0.2,1.2-0.3c2.1-0.7,4-1.4,5.6-2.8c1.7-1.5,2.7-3.8,3.1-6.1c1.1-5.6,0.3-11.9-1.5-17.3 c-1.5-4.3-3.8-8.4-7.2-11.5c-2.6-2.5-6.2-4.6-9.9-3.9c-3.8,0.7-6.6,4.1-8.3,7.7c-2.4,5.4-2.7,11.5-1.5,17.3 c0.9,4.1,2.7,8.1,4.8,11.8c1.3,2.2,3,4.2,5.4,5.2C32.7,72.2,35.5,71.7,38.1,71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "rsvp-present-st0",
    d: "M69,53c-6.2-0.4-11.4-4.3-12.6,2.9c-1.2,7.3,3.1,13.9,9.4,14.9c6.3,1,12.4-4.1,13.5-11.4 C80.4,52.1,75.2,54.4,69,53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "rsvp-present-st0",
    d: "M75.5,7.4c-5.9-0.9-10,3.4-12.7,7.9c-2.9,4.8-4.6,10.3-5,16c-0.2,2.9,0,5.9,0.5,8.8c0.5,2.5,1,5.1,3.1,6.8 c1.4,1.1,3.1,1.6,4.9,2.1c2.5,0.7,5,0.9,7.6,0.9c3.1,0,5.1-1.2,6.8-3.8c3.3-4.8,5.1-10.3,5.5-16.1c0.3-5.3-0.5-11.4-2.9-16.3 c-0.9-1.6-2-3.3-3.4-4.5C78.7,8.2,77.3,7.7,75.5,7.4z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRsvpPresent);
export default __webpack_public_path__ + "static/media/rsvp-present.c14cb2dd5e4eff1092bcceef8908a97b.svg";
export { ForwardRef as ReactComponent };